import { slotColor } from '../metrics.js';
import { severitySlot } from '../lib/concerns.js';
import { useThemeMode } from '../lib/useThemeMode.js';

interface Props {
  value: number | null;
  onChange: (next: number | null) => void;
  /** Accessible label for the group (defaults to "Severity"). */
  label?: string;
}

const LEVELS = [1, 2, 3, 4, 5];

/**
 * A 1–5 severity picker. Each level wears its escalation colour (from the shared
 * palette via severitySlot) when chosen; clicking the active level clears it, so
 * severity stays optional. Keyboard-usable — every level is a real button.
 */
export default function SeveritySeg({ value, onChange, label = 'Severity' }: Props): JSX.Element {
  const mode = useThemeMode();
  return (
    <div className="sevseg" role="group" aria-label={label}>
      {LEVELS.map((n) => {
        const on = value === n;
        return (
          <button
            key={n}
            type="button"
            className={`sevseg__btn${on ? ' sevseg__btn--on' : ''}`}
            aria-pressed={on}
            aria-label={`${label} ${n}`}
            style={on ? { background: slotColor(severitySlot(n), mode), borderColor: 'transparent', color: '#fff' } : undefined}
            onClick={() => onChange(on ? null : n)}
          >
            {n}
          </button>
        );
      })}
    </div>
  );
}
